/*
 * @Author:
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-29 13:13:28
 * @Description:
 * @FilePath: /Cup2Market/src/store/modules/app.js
 */
import { accessLog, getMessage } from "@/api/index";


let login_wechat_func_flag = sessionStorage.getItem("login_wechat_func_flag");
let flag;
if (login_wechat_func_flag === 'false')
{
  flag = false
} else
{
  flag = true
}

const state = {
  interval: null,
  loading: false,
  firstTime: true,
  messageNum: 0,
  wechat_once_login_flag: flag
};
const mutations = {
  M_UPDATE_WECHAT_LOGIN_FLAG(state, flag)
  {
    state.wechat_once_login_flag = flag
  },
  CHANGE_LOADING(state, data)
  {
    state.loading = data;
  },
  SECOND_TIME(state)
  {
    state.firstTime = false;
  },
  SET_INTERVAL(state, data)
  {
    state.interval = data
  },
  MESSAGE_NUM(state, data)
  {
    state.messageNum = data;
  },
};
const actions = {
  // 显示loading
  showLoading({ commit })
  {
    commit("CHANGE_LOADING", true);
  },
  // 隐藏loading
  hideLoading({ commit })
  {
    commit("CHANGE_LOADING", false);
  },

  accessStore({ commit }, customerId)
  {
    return new Promise((resolve, reject) =>
    {
      accessLog({
        type: "store",
        // id: customerId,
      })
        .then((res) =>
        {
          resolve();
        })
        .catch((error) =>
        {
          reject(error);
        });
    });
  },
  secondTime({ commit })
  {
    commit("SECOND_TIME");
  },
  getMessage({ commit })
  {
    getMessage().then(({ data }) =>
    {
      const list = data.filter(item => item.readFlag === false)
      commit("MESSAGE_NUM", list.length);
    })
  },
  getMessageNumStart({ commit })
  {
    console.log('开始监听')
    const getData = () =>
    {
      getMessage().then(({ data }) =>
      {
        const list = data.filter(item => item.readFlag === false)
        commit("MESSAGE_NUM", list.length);
      })
    }
    getData()
    const interval = setInterval(getData, 20 * 1000);
    commit("SET_INTERVAL", interval)
  },
  getMessageNumStop({ commit })
  {
    console.log('结束监听')
    clearInterval(state.interval)
  },
  A_UPDATE_WECHAT_LOGIN_FLAG({ commit }, flag)
  {
    console.log("update flag")
    commit("M_UPDATE_WECHAT_LOGIN_FLAG", flag)
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
